export const environment = {
  production: false,
  api_url: 'https://www.republicservices.com/api/v1',
  end_point: 'https://alb.aiservicesdev.awsext.repsrv.com/api/v1',
  missed_pickup_end_point: 'https://kmapi.aiservicesdev.awsext.repsrv.com/mpu/agent/',
  service_change_end_point: 'https://kmapi.aiservicesdev.awsext.repsrv.com/sc/sc-rag/',
  json_url: './assets/',
  authority: 'https://login.microsoftonline.com/eeb53a15-a2e4-46de-8608-22657ab58979',
  clientId: '1f85072c-d63d-4cf3-9adc-5c5999fcfbf6',
  redirectUri: 'https://kmai.aiservicesdev.awsext.repsrv.com',
  icon_url: './assets/icons/',
  xApiKey: 'Kg44P0vJWi24XkkU2ScHW5yFtuOyMTVp4cu6Y2BF',
  v2_gis_api_key: 'jmy0tuXY3F5rLdqnAg5Zf9NZDndLgjGRazDfqADT',
  v2_kmt_api_key: 'glCzhfOUcY4QXRBhMJX5j2HtDn4C2kyz204p3A2s',
  v2_feedback_api_key: '2xDOWfTWYk6g3C7QJnyXaaTvcajiHTrX3RCvkPIB',
  v2_endpoint: 'https://kmapi.aiservicesdev.awsext.repsrv.com',
  version: 'V2',
  maintenance_banner_message: ``,
};
